import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f213c4ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-header" }
const _hoisted_2 = { class: "fee-detail-content" }
const _hoisted_3 = { class: "fee-detail-log" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { width: "90" }, null, -1))
const _hoisted_5 = { width: "170" }
const _hoisted_6 = { width: "170" }
const _hoisted_7 = { width: "210" }
const _hoisted_8 = { width: "140" }
const _hoisted_9 = {
  style: {"font-weight":"700"},
  width: "140"
}
const _hoisted_10 = { style: {"text-align":"center"} }
const _hoisted_11 = { style: {"vertical-align":"middle"} }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = { class: "text" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "tip" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "name" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = { class: "tip" }
const _hoisted_21 = { class: "tip" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "warn" }
const _hoisted_24 = { class: "name" }
const _hoisted_25 = { class: "text" }
const _hoisted_26 = { class: "tip" }
const _hoisted_27 = { class: "tip" }
const _hoisted_28 = { class: "tip" }
const _hoisted_29 = { class: "tip" }
const _hoisted_30 = { class: "tip" }
const _hoisted_31 = { class: "tip" }
const _hoisted_32 = { class: "tip" }
const _hoisted_33 = { class: "tip" }
const _hoisted_34 = { class: "tip" }
const _hoisted_35 = { class: "tip" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "name" }
const _hoisted_38 = { class: "text" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_41 = { class: "btn" }

import { ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { getOrderFundDetailApi } from '@/apis/fund'
import { useStore } from 'vuex'
import axios from 'axios'
import { exportFileDownload } from '@/util/useExport'
import { useRtfix, isJA } from '@/store'
import { useRouter } from 'vue-router'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { responseReceiptData, ASK_ENUM } from '@/views/setup/components/utils'
import ModalFundFlowContent from '@/views/fund/FundList/components/ModalFundFlowContent.vue'


export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'deliverOrderNo', 'currentUnit', 'countryCode'],
  emits: ['update:visible', 'backAmount'],
  setup(__props, { emit: emits }) {

const props = __props
const [getSignUpValue] = useUserConfig(ENUM_CONFIG_CODE.RETAIL_BOOK)
const router = useRouter()


const cancel = () => {
  emits('update:visible', false)
}
const info: any = ref({})
const getInfo = () => {
  getOrderFundDetailApi({
    deliverOrderNo: props.deliverOrderNo
  }).then((res: any) => {
    if (res.success) {
      info.value = res.data
      emits('backAmount', info.value.totalAmount)
    }
  })
}
watch(() => props.deliverOrderNo, (newValue: any) => {
  if (!newValue) return
  getInfo()
})

/** 保留两位小数，不做四舍五入 */
const getFixedTwo = (value: number) => {
  return String(value).match(/\d+\.?\d{0,2}/)?.[0] ?? '-'
}

const store = useStore()
const exportLoading = ref(false)
const exportPdf = (documentHeader?: string) => {
  console.log(props.deliverOrderNo)
  if (exportLoading.value) return
  exportLoading.value = true
  // TODO
  axios({
    method: 'GET',
    url: process.env.VUE_APP_URL + '/settlement/wallet/fund/flow/exportQingQiuShu',
    responseType: 'blob',
    headers: {
      'X-AuthShopId': store.getters.curShop,
      'X-AuthToken': store.getters.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    },
    params: {
      platformOrderNo: props.deliverOrderNo,
      documentHeader
    }
  }).then(res => {
    exportFileDownload(res, { type: 'application/pdf', name: t('领收书') })
  }).finally(() => {
    exportLoading.value = false
  })
}

const modalFundFlowContentRef = ref<InstanceType<typeof ModalFundFlowContent>>()

const downloadPDF = async () => {
  if (!isJA()) {
    exportPdf()
    return
  }
  const res = await getSignUpValue()
  const lastUseData = responseReceiptData(res)
  if (lastUseData.askEveryTime === ASK_ENUM.NO_ASK) {
    exportPdf(lastUseData.content)
    return
  }
  modalFundFlowContentRef.value?.open(lastUseData.content, (value: string) => {
    exportPdf(value)
  })
}

const jump = () => {
  emits('update:visible', false)
  router.push(useRtfix('StoreFund', { query: { deliverOrderNo: info.value.deliverOrderNo, currencyCode: info.value.currencyCode } }))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonDialog, {
    visible: __props.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    width: 1180,
    onCancel: cancel,
    noHeader: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('国际发货详情2')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('国际发货单号')) + ":" + _toDisplayString(info.value.deliverOrderNo), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(t)('快递公司')) + ":" + _toDisplayString(info.value.distribution), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(t)('运单号')) + ":" + _toDisplayString(info.value.waybillNumberList?.join(',')), 1)
        ]),
        _createElementVNode("table", null, [
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(t)('国际运费')), 1),
            _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(t)('发货附加项2')), 1),
            _createElementVNode("th", _hoisted_7, _toDisplayString(_unref(t)('重量差补扣')), 1),
            _createElementVNode("th", null, _toDisplayString(_unref(t)('国际运费补扣总和')), 1),
            _createElementVNode("th", _hoisted_8, _toDisplayString(_unref(t)('退款')), 1),
            _createElementVNode("th", _hoisted_9, _toDisplayString(_unref(t)('国际发货合计额')), 1)
          ]),
          _createElementVNode("tr", _hoisted_10, [
            _createElementVNode("td", null, _toDisplayString(_unref(t)('金额')) + "(" + _toDisplayString(__props.currentUnit) + ")", 1),
            _createElementVNode("td", null, _toDisplayString(info.value.totalSettlementDeliveryAmount), 1),
            _createElementVNode("td", null, _toDisplayString(info.value.additionSettlementDeliveryAmount), 1),
            _createElementVNode("td", null, _toDisplayString(info.value.deductShipTieredDiffAmount), 1),
            _createElementVNode("td", null, _toDisplayString(info.value.deductShipOtherAmount), 1),
            _createElementVNode("td", null, _toDisplayString(info.value.internationExpressRefundAmount), 1),
            _createElementVNode("td", null, _toDisplayString(info.value.totalAmount), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(t)('详情')), 1),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.settlementDeliveryRespList || [], (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "fee-item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('运单号')) + ":" + _toDisplayString(item.logisticsCode), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('国际运费')) + ": " + _toDisplayString(item.freightFee) + _toDisplayString(__props.currentUnit) + "（" + _toDisplayString(item.weight ?
                getFixedTwo(item.weight) : '') + "kg）", 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('偏远地区费')) + ": " + _toDisplayString(item.remoteAreaFee) + _toDisplayString(__props.currentUnit), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.additionSettlementDeliveryList || [], (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "fee-item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(item.additionNameJp) + ": " + _toDisplayString(item.money) + _toDisplayString(__props.currentUnit), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(item.cost) + _toDisplayString(__props.currentUnit) + "*" + _toDisplayString(item.num) + _toDisplayString(_unref(t)('件')) + "=" + _toDisplayString(item.money) + _toDisplayString(__props.currentUnit), 1)
                ]))
              }), 128)),
              (!(info.value.additionSettlementDeliveryList?.length > 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, "-"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.deductShipTieredDiffInfoList || [], (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "fee-item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('运单号')) + ":" + _toDisplayString(item.transferNumber), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('补扣')) + ": " + _toDisplayString(Math.abs(item.valuationAmountDiff)), 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('我司请求重量')) + ": " + _toDisplayString(item.orderValuationWeight) + "kg(" + _toDisplayString(item.orderValuationWeightAmount
                ??
                '-') + _toDisplayString(__props.currentUnit) + ")", 1),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('快递公司请求重量')) + ": " + _toDisplayString(item.valuationWeight) + "kg(" + _toDisplayString(item.valuationWeightAmount) + _toDisplayString(__props.currentUnit) + ")", 1)
                ]))
              }), 128)),
              (!(info.value.deductShipTieredDiffInfoList?.length > 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, "-"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('※运输公司称重比我司称重的情况下，需要补扣差额。')), 1)
            ]),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.deductShipOtherInfoRespList || [], (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "fee-item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)('运单号')) + ":" + _toDisplayString(item.waybillNumber), 1),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('补扣')) + ": " + _toDisplayString(item.totalFee) + _toDisplayString(__props.currentUnit), 1),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('偏远地区费')) + ": " + _toDisplayString(item.remoteAreaFeeDiff), 1),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)('超长费')) + ": " + _toDisplayString(item.oversizeweightFee), 1),
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)('改派费')) + ": " + _toDisplayString(item.redistributionFee), 1),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)('扣件费')) + ": " + _toDisplayString(item.fastenerFee), 1),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('退件费')) + ": " + _toDisplayString(item.returnFee), 1),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)('销毁费')) + ": " + _toDisplayString(item.destructionFee), 1),
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)('仓储费')) + ": " + _toDisplayString(item.storageFee), 1),
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(t)('退差价')) + ": " + _toDisplayString(item.refundFee), 1),
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)('关税')) + ": " + _toDisplayString(item.tariffFee), 1),
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(t)('特殊处理费')) + ": " + _toDisplayString(item.specialHandlingFee), 1)
                ]))
              }), 128)),
              (!(info.value.deductShipOtherInfoRespList?.length > 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, "-"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.internationExpressRefundFlowList || [], (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "fee-item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(t)('运单号')) + ":" + _toDisplayString(item.logisticsCode), 1),
                  _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(t)('国际运费退款')) + ": " + _toDisplayString(item.refundAmount) + _toDisplayString(__props.currentUnit), 1)
                ]))
              }), 128)),
              (!(info.value.internationExpressRefundFlowList?.length > 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, "-"))
                : _createCommentVNode("", true)
            ]),
            _hoisted_40
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", {
            class: "down",
            onClick: downloadPDF
          }, _toDisplayString(_unref(t)('下载收据')), 1),
          _createElementVNode("div", {
            class: "detail",
            onClick: jump
          }, _toDisplayString(_unref(t)('资金明细2')), 1)
        ])
      ]),
      _createVNode(ModalFundFlowContent, {
        ref: (_value, _refs) => {
          _refs['modalFundFlowContentRef'] = _value
          modalFundFlowContentRef.value = _value
        }
      }, null, 512)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})